// extracted by mini-css-extract-plugin
export default {"wrapper":"mail-server-error-modal_wrapper__xYclu","closeBtn":"mail-server-error-modal_closeBtn__B1lcQ","opacity-transition":"mail-server-error-modal_opacity-transition__WS3fH"};